import { render, staticRenderFns } from "./AdminConfirmationsSection.vue?vue&type=template&id=aecd92bc&"
import script from "./AdminConfirmationsSection.vue?vue&type=script&lang=js&"
export * from "./AdminConfirmationsSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports